/* eslint-disable max-len */
/* eslint-disable import/prefer-default-export */
/**
 * Innovation Guild: search only experiment, article search action.
 */
import has from 'lodash/has';
import axios from 'axios';
import * as types from '../../js/contactUs/constants/ActionTypes';

// Helpers.
import { docTypeOptions } from '../../js/lib/customFields';
import { trackPage } from '../../js/lib/analytics-helper';
import Page from '../../js/lib/page';
import { searchType, searchParser, getFullSearchCount, searchAnalytics } from '../../js/lib/insightHelper';
import getOpenDisputes from '../../js/home/actions/action-dispute-transactions';
import updateUserSelection from '../updateUserSelection';
import { isShowOnlySearchLayoutEnabled, isBotExperienceEnabled } from '../helper';
import { asyncParamDeviceType } from '../../js/common/commonConstants';

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

function requestArticleSearch() {
  return {
    type: types.REQUEST_ARTICLE_SEARCH,
    payload: undefined,
  };
}

function receiveArticleSearchResult(searchTerm, experience, responseData, documentType) {
  return {
    type: types.RECEIVE_ARTICLE_SEARCH_RESPONSE,
    payload: {
      q: searchTerm,
      experience,
      items: responseData,
      channel: documentType,
    },
  };
}

function receiveArticleSearchError(searchTerm, experience, documentType) {
  return {
    type: types.RECEIVE_ARTICLE_SEARCH_ERROR,
    payload: {
      q: searchTerm,
      experience,
      channel: documentType,
    },
  };
}

export const fetchArticleSearchOnlyFaqBot = (searchTerm, experience, channel) => {
  const documentType = has(docTypeOptions, channel) ? channel : 'faq';
  const device = asyncParamDeviceType[Page.getDeviceType()];
  const trackLinkOption = {
    id: 'searchPage',
    link: `smarthelp-search-filter-document-type|${documentType}|selfServiceSearch`,
    srch: searchTerm,
  };

  return (dispatch) => {
    // shows loading spinner
    dispatch(requestArticleSearch());

    if (Page.isLoggedIn()) {
      // dispatching to get if any pending disputes exist so that we can display the message to user only when user is logged-in
      dispatch(getOpenDisputes());
    }
    // To Check for Only Search Experiment
    const onlySearch = isShowOnlySearchLayoutEnabled();
    // To Check for Bot Experiment
    const botEnabled = isBotExperienceEnabled();

    const articleSearchUrl = `/smarthelp/km-full-search-only-faq-bot?q=${Page.getSanitizedValue(
      searchTerm,
    )}&exp=${experience}&channel=${documentType}&onlySearch=${onlySearch}&botEnabled=${botEnabled}`;
    if (onlySearch) {
      trackLinkOption.link = `smarthelp-search-filter-document-type|${documentType}|${device}|search-only-faq-exp|okmFullSearch`;
    } else {
      trackLinkOption.link = `smarthelp-search-filter-document-type|${documentType}|okmFullSearch`;
    }

    return axios
      .get(articleSearchUrl, {
        cancelToken: source.token,
      })
      .then((response) => {
        if (response.data && response.data.smc === true) {
          trackLinkOption.id = 'BotConversation';
          trackLinkOption.link = `smarthelp-search-filter-document-type|${documentType}|${device}|createNewBotConversation`;
          trackPage(trackLinkOption);
          if (device === 'mweb') {
            window.nodeChat.showAsync(response.data.conversationId, { conversation: '', topicName: 'GENPOOL' });
            dispatch(receiveArticleSearchResult(searchTerm, experience, [], documentType));
          } else {
            window.location.href = '/smc/async/home';
            dispatch(receiveArticleSearchResult([]));
          }
        } else {
          trackPage(trackLinkOption);
          dispatch(receiveArticleSearchResult(searchTerm, experience, response.data, documentType));
          searchAnalytics(
            searchParser({
              count: getFullSearchCount(response.data),
              type: searchType.fullSearch,
              query: searchTerm,
              csrf: Page.getCSRFtoken(),
            }),
          );
        }
        dispatch(updateUserSelection('GENPOOL', 'HELP_CENTER'));
      })
      .catch(() => {
        // Error impression event in the search result page
        trackLinkOption.id = 'searchErrorPage';
        trackLinkOption.link = `smarthelp-error-search|filter-type|${documentType}`;
        trackPage(trackLinkOption);
        dispatch(receiveArticleSearchError(searchTerm, experience, documentType));
        searchAnalytics(
          searchParser({
            count: 0,
            type: searchType.fullSearch,
            query: searchTerm,
            csrf: Page.getCSRFtoken(),
          }),
        );
        dispatch(updateUserSelection('GENPOOL', 'HELP_CENTER'));
      });
  };
};
